export default __webpack_public_path__ + "static/media/courthouse.ecf5fe1d.png";